const createAction = type => () => ({
  type,
})

export default createAction
